import { FC, ReactElement, useRef } from 'react'

import { SidebarPageWrapper } from '../../components'
import { Sidebar } from '../../compositions'
import {
    ConnectedLeaveOfAbsencesOverviewFilter,
    ConnectedLeaveOfAbsencesOverviewTable,
    ConnectedLeaveOfAbsencesOverviewTopBar,
    ConnectedLeaveOfAbsencesOverviewUsers,
} from '../../connectors'

import './LeaveOfAbsencesOverviewPage.scss'

const LeaveOfAbsencesOverviewPage: FC = (): ReactElement => {
    const mainElementRef = useRef<HTMLElement>(null)

    return (
        <SidebarPageWrapper>
            <Sidebar isOpenedClassName="leave-of-absences-overview-page__sidebar--is-opened">
                <ConnectedLeaveOfAbsencesOverviewFilter />
            </Sidebar>
            <main ref={mainElementRef} className="leave-of-absences-overview-page__main">
                <ConnectedLeaveOfAbsencesOverviewUsers />
                <div className="leave-of-absences-overview-page__table-container">
                    <ConnectedLeaveOfAbsencesOverviewTopBar className="leave-of-absences-overview-page__top-bar" />
                    <ConnectedLeaveOfAbsencesOverviewTable
                        className="leave-of-absences-overview-page__table"
                        scrollElementRef={mainElementRef}
                    />
                </div>
            </main>
        </SidebarPageWrapper>
    )
}

export default LeaveOfAbsencesOverviewPage
